<template>
    <div>
        <universal-uploader
            @uploadSuccess="uploadSuccess"
            class="text-truncate"
            :clientAllowedFormats="['video']"
        >
            <b-btn
                variant="light"
                class="d-flex align-items-center"
                pill
                size="sm"
            >
                <font-awesome-icon class="mr-1" icon="fa-duotone fa-video" />
                {{ $t("Video") }}
            </b-btn>
        </universal-uploader>
    </div>
</template>

<script>
import UniversalUploader from "@/components/universalUploader/UniversalUploader";

export default {
    methods: {
        uploadSuccess(url) {
            this.$store.commit("createPostVideo/queueUpload", url);
            this.$store.dispatch("createPostVideo/scheduleQueueProcessing");
        },
    },
    components: {
        UniversalUploader,
    },
};
</script>

